import {
  Component,
  OnInit,
  Output,
  Input,
  HostBinding,
  EventEmitter,
  HostListener,
  ViewEncapsulation } from '@angular/core';
import { IService   } from '../providers/interfaces';

export interface IPlayEvent {
  play: boolean;
  service: number;
}

@Component({
  selector: 'app-lecture-list-item',
  templateUrl: './lecture-list-item.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./lecture-list-item.component.scss']
})
export class LectureListItemComponent implements OnInit {

  @Input()
  service: IService;

  @Input()
  currentService: number;

  @Output( 'playEvent' )
  playEvent: EventEmitter<IPlayEvent> = new EventEmitter();

  @HostBinding('class.playing')
  public playing = false

  constructor() { }

  togglePlayAudio() {
    this.playing = !this.playing;
    this.playEvent.emit( { play: this.playing, service: this.service.id } );
  }

  showYoutube(url: string) {
    window.open(url);
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/lecture-list-item/lecture-list-item.component.ts